if (!customElements.get('linked-products')) {
  class LinkedProducts extends HTMLElement {
    constructor() {
      super();
      this.setVeriables();
      this.setEventListeners();
    }
    setVeriables(){
      this.metalOptions = document.querySelector(".custom-select--metal .custom-options-list");
      this.abbrValues = {
				X: 'yellow-white',
				U: 'white-yellow',
				Z: 'rose-white',
				V: 'white-rose',
				Y: 'yellow',
				W: 'white',
				R: 'rose',
			};
    }
    setEventListeners(){
      this.metalOptions.addEventListener("click", this.onMetalOptionClick.bind(this));
      this.productsElemets = Array.from(this.querySelectorAll("a[data-linked-product]"));
    }
    onMetalOptionClick(event){
      const activeMetalEl = event.target.closest(".custom-option");
				if (!activeMetalEl) return;
			const activeMetalInput = activeMetalEl.querySelector("input");
      this.changeImage(activeMetalInput);
      this.changeVariant(activeMetalInput);
    }
    changeImage(activeMetalInput){
      const abbreviation = activeMetalInput.getAttribute("data-metal-abbreviation");
      const imageMetalValue = this.abbrValues[abbreviation];
      this.productsElemets.forEach(element=>{
        const imageEl = element.querySelector("img");
        const newUrl = imageEl.getAttribute(`data-src-${imageMetalValue}`);
        imageEl.src = newUrl;
      })
    }
    changeVariant(activeMetalInput){
      const metalValue = activeMetalInput.value;
      const metalValueArr = metalValue.split(" ")
      const karat = metalValueArr[0];
      this.productsElemets.forEach(element=>{
        const variants = JSON.parse(element.querySelector("script").textContent);
        const baseUrl = element.getAttribute("data-base-url")
        let relevantVariant = variants.find(variant=>variant.options.includes(metalValue));
        if(!relevantVariant){
          relevantVariant = variants.find(variant=>variant.options.find(option=>option.includes(metalValueArr.slice(1).join(" "))));
        }
        if(!relevantVariant){
          relevantVariant = variants.find(variant=>variant.options.find(option=>option.includes(metalValueArr[1])));
        }
        if(!relevantVariant && metalValue.includes("Platinum")){
          relevantVariant = variants.find(variant=>variant.options.find(option=>option.toLowerCase().includes("white")));

        }
        if(relevantVariant){
          element.href=baseUrl + relevantVariant.id
        }
      })
    }
  }
  customElements.define('linked-products', LinkedProducts);
}